import { NotLivePage } from '@/app/notLive'
import { SectionFrame } from '@/app/pages'
import type { RouteDef } from '@/app/routes'

/**
 * A Market Intelligence page while its data source is not live: the page's
 * title and tabs, then "Not live yet" in place of every figure and every
 * add or import control, so nothing can be entered that would not be kept.
 */
export function NotLiveSection({ route }: { route: RouteDef }) {
  return (
    <SectionFrame route={route}>
      <NotLivePage />
    </SectionFrame>
  )
}
